import React from 'react';
import { FaEllipsis } from 'src/shared/design-system/FontAwesome';
import { SpiceTag } from 'src/shared/design-system/SpiceTag/SpiceTag';
import { DietaryIconImg } from 'src/shared/utils/IconUtils';
import styled from 'styled-components';
import { DietaryTags } from 'web-common/src/shared/Enums';
import { Colors, Spacing } from 'web-common/src/shared/styles';

const ICON_SIZE = '16px';
const FoodItemIconWrapper = styled.div`
  height: ${ICON_SIZE};
  display: flex;
  align-items: center;

  gap: ${Spacing.HALF};
`;

interface IProps {
  className?: string;
  tags: DietaryTags[];
  spiceLevel: number;
}

const Ellipsis = styled(FaEllipsis)`
  font-size: ${ICON_SIZE};
  margin-bottom: -7px;
  color: ${Colors.GRAY_DARK_20};
`;

export const DietaryTagIconSet: React.FC<IProps> = ({ className, tags, spiceLevel }) => {
  // No more than 5 icons total - ellipsis counts as one
  const spiceTagCount = spiceLevel > 0 ? 1 : 0;
  const tooManyTags = (tags?.length ?? 0) + spiceTagCount > 4;
  const displayableTags = tooManyTags ? tags.slice(0, 4 - spiceTagCount) : tags;

  return (
    <FoodItemIconWrapper className={className}>
      {spiceLevel !== 0 && <SpiceTag spiceLevel={spiceLevel} imageSize='16px' />}
      {displayableTags.map<React.ReactNode>((dietaryTag) => (
        <DietaryIconImg key={dietaryTag} dietaryTag={dietaryTag} styles={{ width: '16px' }} />
      ))}
      {tooManyTags && <Ellipsis />}
    </FoodItemIconWrapper>
  );
};
